<template>
  <div>
    <p>Step 3</p>
    <pre>
      {{ items }}
    </pre>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "BrandArchitectureStep3",
  data() {
    return {
      items: this.value,
    };
  },
  props: {
    value: Object,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
